import { useEffect } from "react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useBusiness } from "@hooks/useBusiness";

const SEPARATOR = " • ";
const BRAND = "Stocko";

/**
 * Keeps the browser tab title as "<Store name> • <Nav destination> • Stocko".
 *
 * The middle part is the *sidebar* destination rather than the deepest
 * breadcrumb, so /store/zeri/products/abc123 reads "Products", not the raw id.
 * usePageMeta already strips the /store/<handle> prefix, so the destination is
 * the first breadcrumb entry.
 *
 * Parts drop out cleanly while data is still loading: with no business resolved
 * yet the title is "Products • Stocko" rather than " • Products • Stocko".
 */
export function useDocumentTitle() {
  const { breadcrumb } = usePageMeta();
  const { business } = useBusiness();

  const storeName = business?.name || "";
  const navDestination = breadcrumb[1] || breadcrumb[0] || "";

  useEffect(() => {
    document.title = [storeName, navDestination, BRAND].filter(Boolean).join(SEPARATOR);
  }, [storeName, navDestination]);
}

export default useDocumentTitle;
